<template>
  <section>
    <div class="package_top">
      <div class="package_top_left">
        <span class="package_top_span">优惠类型</span>
      </div>
      <div class="package_top_right" @click="toallList()" v-if="allPrkParkFeeBeanList.length>3">
        <span class="package_top_span1">更多</span>
        <img class="package_top_icon" src="../../../assets/images/icon_indicator_next.png" />
      </div>
    </div>
    <section class="package_box">
      <!-- newParkingMess -->
      <section
        :class="['package_item',ParkFeeId==item.id?'cur':'', lprkParkFeeBeanList.length == 1?'package_item_one':'']"
        v-for="item in lprkParkFeeBeanList"
        :key="item.id"
        @click="select(item)"
      >
        <!-- 是租户且有租户折扣显示折扣图标 -->
        <img
          v-if="isUser && item.enableCompanyDiscount == 1"
          class="discount"
          src="../../../assets/images/discount.png"
        />
        <div class="h3div">
          <span class="h3Span" v-if="item.parkTypeName">{{item.parkTypeName}}</span>
          <span class="h3Span" v-else>{{item.dayNightType|parkTypeName}}</span>
        </div>
        <p v-if="item.dayNightType == 1" class="time_range">24小时</p>
        <p
          v-else-if="item.dayNightType == 2"
          class="time_range"
        >{{parkingMess.dayStartHour}}-{{parkingMess.dayEndHour}}</p>
        <p v-else class="time_range">
          {{parkingMess.nightStartHour}}-{{parkingMess.nightEndHour}}
          <span>+1</span>
        </p>
        <section class="price_box" v-if="!isUser || item.enableCompanyDiscount != 1">
          <p>{{item.feeStandard}}</p>
          <span>元/月</span>
        </section>
        <template v-else>
          <section class="price_box">
            <p>{{item.companyDiscount.toFixed(2)}}</p>
            <span>元/月</span>
          </section>
          <p class="underline_text">{{item.feeStandard}}元</p>
        </template>
        <img
          v-if="item.dayNightType == 1"
          class="icon_t"
          src="../../../assets/images/parking/icon_all_day.png"
        />
        <img
          v-else-if="item.dayNightType == 2"
          class="icon_t"
          src="../../../assets/images/parking/icon_daytime.png"
        />
        <img v-else class="icon_t" src="../../../assets/images/parking/icon_night.png" />
        <img
          v-if="dayNightType == item.dayNightType"
          class="icon_select"
          src="../../../assets/images/selected.png"
        />
      </section>
    </section>
    <img
      v-if="!isUser && hasDiscount"
      class="identity"
      @click="toCompany"
      src="../../../assets/images/ident.jpg"
      alt
    />
  </section>
</template>

<script>
import storage from '../../../utils/storage';
export default {
  props: {
    parkingMess: {
      type: Object,
      default: () => { }
    },
    dayNightType: {
      type: Number,
      default: 1
    },
    ParkFeeId: '',
    ParkFeeSelectItem:''
  },
  watch: {
    parkingMess() {
      if (this.parkingMess) {
        if (this.parkingMess.prkParkFeeBeanList) {
          var list1 = [];
          for (var i = 0; i < this.parkingMess.prkParkFeeBeanList.length; i++) {
            var item = this.parkingMess.prkParkFeeBeanList[i];
            if (item.parkType == 4) {
              list1.push(item);
            }
          }
          this.allPrkParkFeeBeanList = list1;
          var num = 3;
          var list = [];
          if (list1.length < 3) {
            num = list1.length;
          }
          for (var j = 0; j < num; j++) {
            list.push(list1[j]);
          }
          this.lprkParkFeeBeanList = list;
        } else {
          this.allPrkParkFeeBeanList = [];
          this.lprkParkFeeBeanList = [];
        }
        this.newParkingMess && this.newParkingMess.forEach(item => {
          if (item.companyDiscount < 100) {
            this.hasDiscount = true;
          }
        })

      }
    },

    ParkFeeSelectItem() {
      if (this.ParkFeeSelectItem) {
        var tempItem = this.lprkParkFeeBeanList[0];
        for (var i = 0; i < this.lprkParkFeeBeanList.length; i++) { //原数组已经存在选项
          var item = this.lprkParkFeeBeanList[i];
          if (this.ParkFeeSelectItem.id == item.id) {
            this.lprkParkFeeBeanList[i] = tempItem;
          }
        }
        // this.getMyDiscountParkLot()
        this.lprkParkFeeBeanList[0] = this.ParkFeeSelectItem;
        this.select(this.ParkFeeSelectItem);
      }
    }
  },
  filters: {
    parkTypeName(val) {
      if (val == 1) {
        return '全天'
      } else if (val == 2) {
        return '日间'
      } else {
        return '夜间'
      }
    }
  },
  computed: {
    newParkingMess() {
      let newL = this.parkingMess && this.parkingMess.prkParkFeeBeanList && this.parkingMess.prkParkFeeBeanList.filter(item => {
        return item.parkType == 4
      })
      return newL
    },
    // 停车分类 parkType（1、临停计费标准；2、优惠临停计费标准；3、公司月租；4、个人月租；5、公司月租超额;6、月租充值优惠）
    //昼夜模式 dayNightType 1、全天；2、白天；3夜晚
    // 全保的价格
  },
  data() {
    return {
      isUser: false,
      hasDiscount: false,
      lprkParkFeeBeanList: "",
      allPrkParkFeeBeanList: '',
    }
  },
  created() {
    if (Object.keys(this.$store.state.common.userTenantInfo).length > 0) {
      this.isUser = true
    }
    // console.log("parkingMess   =====  " + JSON.stringify(this.parkingMess))
    if (this.parkingMess.prkParkFeeBeanList) {
      var list1 = [];
      for (var i = 0; i < this.parkingMess.prkParkFeeBeanList.length; i++) {
        var item = this.parkingMess.prkParkFeeBeanList[i];
        if (item.parkType == 4) {
          list1.push(item);
        }
      }
      this.allPrkParkFeeBeanList = list1;
      // console.log("parkingMess   =====  " + JSON.stringify(list1))
      var num = 3;
      var list = [];
      if (list1.length < 3) {
        num = list1.length;
      }
      for (var j = 0; j < num; j++) {
        list.push(list1[j]);
      }
      this.lprkParkFeeBeanList = list;
    } else {
      this.allPrkParkFeeBeanList = [];
      this.lprkParkFeeBeanList = [];
    }

    this.newParkingMess && this.newParkingMess.forEach(item => {
      if (item.companyDiscount < 100) {
        this.hasDiscount = true;
      }
    })

  },
  methods: {
    select(item) {
      this.$emit("packageChange", item)
    },
    toCompany() {
      this.$router.push({
        path: "/companyList"
      });
    },
    toallList() {
      // for(var i=0;i<10;i++){
      //   this.allPrkParkFeeBeanList.push(this.allPrkParkFeeBeanList[0]);
      // }

      storage.setS("FeeListparkingMess", JSON.stringify(this.parkingMess))
      storage.setS("allPrkParkFeeBeanList", JSON.stringify(this.allPrkParkFeeBeanList))
      // storage.setS("userData",JSON.stringify(res.body))

      this.$router.push({
        path: "/parkFeeList?dayNightType=" + this.dayNightType + "&isUser=" + this.isUser + "&ParkFeeId=" + this.ParkFeeId
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
.package_top {
  flex-direction: row;
  display: flex;
  // margin-top: 28px;
  width: 100%;
  // height: 70px;
  background-color: #ffffff;
  padding-top: 28px;
  justify-content: space-between;
  // background-color: red;
}
.package_top_left {
  flex-direction: row;
  margin-left: 28px;
}
.package_top_span {
  height: 42px;
  font-size: 30px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 42px;
}
.package_top_right {
  flex-direction: row;
  margin-right: 28px;
}
.package_top_span1 {
  height: 42px;
  font-size: 30px;
  font-weight: 400;
  color: rgba(201, 201, 201, 1);
  line-height: 42px;
}
.package_top_icon {
  margin-top: -4px;
  margin-left: 4px;
  width: 32px;
  height: 32px;
}
.package_box {
  background: #fff;
  padding: 28px 13px;
  .flex();
  .package_item {
    flex: 1;
    flex-shrink: 0;
    margin: 0 7px;
    padding-left: 16px;
    // height:176px;
    border-radius: 8px;
    border: 4px solid rgba(239, 239, 239, 1);
    box-sizing: border-box;
    position: relative;
    background: rgba(248, 248, 248, 1);
    .discount {
      position: relative;
      left: -20px;
      top: -4px;
      width: 132px;
      height: 40px;
    }
    .img_h {
      height: 40px;
    }
    .underline_text {
      text-decoration: line-through;
      font-size: 24px;
      color: #999;
      margin-bottom: 20px;
    }
    .h3div {
      width: 140px;
      display: flex;
      .h3Span {
        font-size: 28px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 34px;
        //   height: 80px;
        width: 140px;
        margin-top: 16px;
        margin-bottom: 10px;
        // white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        lines: 2;
        max-lines: 2;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    .time_range {
      white-space: nowrap;
      height: 32px;
      font-size: 24px;
      color: rgba(102, 102, 102, 1);
      line-height: 32px;
      margin-bottom: 14px;
      span {
        font-size: 20px;
        color: #16bc84;
      }
    }
    .price_box {
      .flex();
      align-items: flex-end;
      margin-bottom: 12px;
      p {
        font-size: 44px;
        color: rgba(252, 63, 86, 1);
        margin-right: 4px;
      }
      span {
        font-size: 26px;
        color: rgba(51, 51, 51, 1);
        line-height: 36px;
      }
    }
    .icon_t {
      position: absolute;
      top: 20px;
      right: 24px;
      width: 28px;
      height: 28px;
    }
    .icon_select {
      position: absolute;
      bottom: -2px;
      right: -3px;
      width: 36px;
      height: 36px;
      display: none;
    }
  }
  .cur {
    background: rgba(246, 248, 254, 1);
    border: 4px solid rgba(23, 64, 218, 1);
    .icon_select {
      display: block;
    }
  }
  .package_item_one {
    width: 348px;
    flex: 0 1 auto;
  }
}
.identity {
  display: block;
  padding: 0 20px 28px 20px;
  width: 100%;
  height: auto;
  box-sizing: border-box;
  background: #fff;
}
</style>
